// @ts-nocheck
import '@styles/global.scss';
import React, { useEffect } from 'react';
import { Route, BrowserRouter, Routes } from 'react-router';
import { useTranslation } from 'react-i18next';
import Config from './config/_global';
import {
    ENV_TYPES,
} from '../js/_constants';
import { generalStore, userStore } from '../store';
import InitialView from '../views/initialView/InitialView';
import ItemView from '../views/itemView/ItemView';
import DashboardView from '../views/dashboardView/DashboardView';
import DevicesView from '../views/devicesView/DevicesView';
import DealershipsView from '../views/dealershipsView/DealershipsView';
import DealershipDevicesView from '../views/dealershipDevicesView/DealershipDevicesView';
import DeviceDetailsView from '../views/deviceDetailsView/DeviceDetailsView';
import MediaLibraryView from '../views/mediaLibraryView/MediaLibraryView';
import PlaylistsView from '../views/playlistsView/PlaylistsView';
import PlaylistDetailView from '../views/playlistDetailView/PlaylistDetailView';
import PlaylistGroupDetailView from '../views/playlistGroupDetailView/PlaylistGroupDetailView';
// import OnboardingView from '../views/onboardingView/OnboardingView';
import FaqsView from '../views/faqsView/FaqsView';
import ProfileView from '../views/profileView/ProfileView';
import WelcomeScreenView from '../views/iframes/WelcomeScreenView/WelcomeScreenView';
import PrivateRoute from '../components/privateRoute/PrivateRoute';
import IFrameRoute from '../components/iFrameRoute/iFrameRoute';
import NoAuthRoute from '../components/noAuthRoute/NoAuthRoute';
import NavigationManager from '../components/navigationManager/NavigationManager';
import ErrorView from '../views/errorView/ErrorView';
import ConnectView from '../views/connectView/ConnectView';
import GrpView from '../views/grpView/GrpView';
import { ROUTES } from './_constants';

const App = () => {
    const { t, i18n } = useTranslation();
    const { setAlert } = generalStore();
    const { details } = userStore();
    const isInIframe = window.self !== window.top;

    useEffect(() => {
        document.title = `${Config.clientName} - New Retail Content Manager`;
    }, []);

    useEffect(() => {
        const currentLanguageCode = i18n.language || 'en';
        i18n.changeLanguage(currentLanguageCode);
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                {isInIframe ? (
                    <>
                        <Route path={ROUTES.IFRAME_WELCOME_SCREEN} element={<IFrameRoute component={WelcomeScreenView} />} />
                        <Route path="*" element={<IFrameRoute component={WelcomeScreenView} />} />
                    </>
                ) : (
                    <>
                        <Route
                            path={ROUTES.NO_AUTHENTICATED}
                            element={<NoAuthRoute component={InitialView} />}
                        />
                        <Route
                            path={ROUTES.CONNECT}
                            element={<NoAuthRoute component={ConnectView} />}
                        />
                        <Route
                            path={ROUTES.GRP}
                            element={<NoAuthRoute component={GrpView} />}
                        />
                        {/* <PrivateRoute
                            component={OnboardingView}
                        /> */}
                        <Route path={ROUTES.DASHBOARD} element={<PrivateRoute component={DashboardView} />} />
                        <Route path={ROUTES.FAQS} element={<PrivateRoute component={FaqsView} />} />
                        <Route path={`${ROUTES.VIDEOS}/:id`} element={<PrivateRoute component={ItemView} />} />
                        <Route path={`${ROUTES.IMAGES}/:id`} element={<PrivateRoute component={ItemView} />} />
                        <Route path={`${ROUTES.DEALERSHIPS}${ROUTES.DEVICES}/:id`} element={<PrivateRoute component={DeviceDetailsView} />} />
                        <Route path={ROUTES.PROFILE} element={<PrivateRoute component={ProfileView} />} />
                        <Route path={ROUTES.PLAYLISTS} element={<PrivateRoute component={PlaylistsView} />} />
                        <Route path={`${ROUTES.PLAYLISTS}/:id`} element={<PrivateRoute component={PlaylistDetailView} />} />
                        <Route path={`${ROUTES.PLAYLISTS}/groups/:id`} element={<PrivateRoute component={PlaylistGroupDetailView} />} />
                        <Route path={ROUTES.DEVICES} element={<PrivateRoute component={DevicesView} />} />
                        <Route path={ROUTES.DEALERSHIPS} element={<PrivateRoute component={DealershipsView} />} />
                        <Route path={`${ROUTES.DEALERSHIPS}/:id`} element={<PrivateRoute component={DealershipDevicesView} />} />
                        <Route path={ROUTES.MEDIA_LIBRARY} element={<PrivateRoute component={MediaLibraryView} />} />
                        {/*
                        <PrivateRoute
                            component={ItemView}
                        />
                        <PrivateRoute
                            component={ItemView}
                        />
                        */}
                        {details.isWelcomeScreenEnabled && <Route path={ROUTES.WELCOME_SCREEN_PAGE} element={<PrivateRoute component={WelcomeScreenView} />} />}
                        <Route path="*" element={<ErrorView />} />
                    </>
                )}
            </Routes>
            <NavigationManager />
        </BrowserRouter>
    );
};

export default App;
